export default __webpack_public_path__ + "static/media/checkmark.55474ccf.svg";